import * as React from 'react';

import LoginContainer from '../containers/LoginSso';

const LoginSso: React.FC<any> = props => {
	return <LoginContainer {...props} />;
};

export default LoginSso;



// WEBPACK FOOTER //
// ./src/pages/LoginSso.tsx